import { render, staticRenderFns } from "./TestRich.vue?vue&type=template&id=3c18291c"
import script from "./TestRich.vue?vue&type=script&lang=js"
export * from "./TestRich.vue?vue&type=script&lang=js"
import style0 from "./TestRich.vue?vue&type=style&index=0&id=3c18291c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports